var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 3h4V2a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h1V2a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1zM3 7v2h2V7H3zm4 0v2h2V7H7zm4 0v2h2V7h-2zm-4 4v2h2v-2H7zm-4 0v2h2v-2H3zm1-9v3h1V2H4zm7 0v3h1V2h-1z"}));
}

Calendar.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Calendar;

Calendar.default = Calendar;
